import { defineStore, storeToRefs } from 'pinia';
import useSystemStore from '@store/system';
import useAudioStore from '@store/audio';
import { postGenCost } from '@/service/gen';

type AudioTab = 'audio_text' | 'audio_import' | 'audio_record';

const name = 'avatar';

export default defineStore(name, {
  state: () => ({
    isFocus: false,
    isImportAudio: false,
    isAssetsHasData: false,
    isGenLoading: false,
    isSelectChangeVoice: false,
    isTransparency:
      localStorage.getItem('isTransparency') === 'true' ? true : false,
    isHD: localStorage.getItem('isHD') === 'true' ? true : false,
    audioTab: 'audio_text' as AudioTab,
    textareaRef: null as any,
    genBlankTaskNum: 0,
    prompt: sessionStorage.getItem('prompt') || '',
    exampleList: [] as GenVideoItem[],
    copyUserAvatarList: [] as AvatarItem[],
    activeAvatar: {} as AvatarItem,
    activeGenVideoItem: {} as GenVideoItem,
    costCredits: 0, // 预估消耗credits
    costDetails: {} as CostDetails,
    activeEmotionIndex: 0,
    activeRemoveNoiseIndex:
      localStorage.getItem('isDenoise') === 'true' ? 1 : 0,
    sampleStepsMax: 4,
    sampleSteps: Number.parseInt(localStorage.getItem('sampleSteps') || '0'),
    aspectRatioList: ['9:16', '1:1', '16:9'] as string[],
    aspectRatio: localStorage.getItem('aspectRatio') || '9:16',
  }),

  actions: {
    async resetgenBlankTaskNum() {
      this.genBlankTaskNum = 0;
    },
    async resetEmotionIndex(name: string) {
      const systemStore = useSystemStore();
      const { emotion_list } = storeToRefs(systemStore);

      emotion_list.value.map((emotionItem, index) => {
        if (emotionItem?.code === name) {
          this.activeEmotionIndex = index;
        }
      });
    },
    async handleAspectRatio(ratio: string, isDisabled: boolean) {
      if (isDisabled) {
        return;
      } else {
        this.aspectRatio = ratio;
        localStorage.setItem('aspectRatio', ratio);
      }
    },
    async genCost() {
      const audioStore = useAudioStore();
      const { activeAudioRegion } = storeToRefs(audioStore);

      const res = await postGenCost({
        prompt: this.prompt,
        duration:
          activeAudioRegion?.value?.end - activeAudioRegion?.value?.start || 0,
        transparency: this.isTransparency ? 1 : 0,
        hd_type: this.isHD ? 1 : 0,
      });

      this.costCredits = res?.cost_credit || 0;
      this.costDetails = res?.cost_detail || 0;
    },
  },
});
